import { Grid2 as Grid } from '@mui/material';
import { DashboardItemWithSections, DashboardSectionConfig } from 'domain/shared/core/dashboard';
import { useStaffingDashboardCallbacks } from 'domain/staffing/dashboard/dashboard/hooks/useStaffingDashboardCallbacks';
import StaffingProjectGeneralInfo from 'domain/staffing/dashboard/dashboard/List/StaffingProjectGeneralInfo';
import { useStaffingProjectContext } from '../context/StaffingProjectContext';

const SECTIONS_CONFIG: DashboardSectionConfig = {
  followUps: { enabled: true, maxItems: 20 },
  issues: { enabled: true, maxItems: 3, showSeverityColors: true },
  people: { enabled: true },
};

const StaffingProjectOverview = () => {
  const { refetch } = useStaffingProjectContext();
  const { projectData, menuOptions, handleFollowUpRemove, handleFollowUpUpdate } =
    useStaffingDashboardCallbacks(refetch);
  if (!projectData) return null;

  return (
    <Grid container spacing={2} alignItems="flex-start">
      <Grid size={{ xs: 4 }}>
        <StaffingProjectGeneralInfo />
      </Grid>
      <Grid size={{ xs: 8 }}>
        <DashboardItemWithSections
          item={projectData}
          sectionsConfig={SECTIONS_CONFIG}
          menuOptions={menuOptions}
          onFollowUpRemove={handleFollowUpRemove}
          onFollowUpUpdate={handleFollowUpUpdate}
        />
      </Grid>
    </Grid>
  );
};

export default StaffingProjectOverview;
